/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { object } from 'prop-types';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import withStyles from '@material-ui/core/styles/withStyles';
import mbpLogger from 'mbp-logger';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import { GRAPHQL_ENV } from '../../../gql';
import DesktopGraphqlFooter from './DesktopGraphqlFooter';
import MobileGraphqlFooter from './MobileGraphqlFooter';
import brandThemes from '../../AppShell/brandtheme';
import { setLocale } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    appFooter: {
        color: theme.palette.grey['50'],
        marginTop: theme?.palette?.footer?.marginTop,
    },
    mobileFooter: {
        display: 'block',
        backgroundColor: theme.palette.modalBg || '#f2f2f2',
        paddingBottom: '20px',
    },
    desktopFooter: {
        backgroundColor: theme.palette.desktopBgFooter,
    },
    addonPageDesktopFooter: {
        width: '100%',
    },
});
class GraphqlFooter extends PureComponent {
    checkTitle = (dataTitle, checkTitle, checkDefault = '') => (
        ((checkTitle === dataTitle.split(' ').join('').toLowerCase()) || (checkDefault === dataTitle.split(' ').join('').toLowerCase()))
    );

    render() {
        const {
            brand, classes,
        } = this.props;

        const FOOTER_QUERY = gql`
            query FooterQuery {
                findFooter(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", locale: "${setLocale()}") {
                    content
                }
            }
        `;

        const addonPageFooter  = (typeof window === 'object') ? (/add-ons/.test(window.location.pathname)) : false;
        const addonCartPage  = (typeof window === 'object') ? (window.location.pathname.indexOf('/cart/') !== -1) : false;
        const presentationFamily = brandThemes[brand?.code]?.presentation_family;
        // const tealiumCookies = getTealiumCookies();

        return (
            <footer id="global_footer_container" className={addonPageFooter || addonCartPage ? `${classes.addonPageDesktopFooter} ${classes.appFooter}` : `${classes.appFooter}`}>
                <Query query={FOOTER_QUERY}>
                    {({ loading, error, data }) => {
                        if (loading) {
                            return null; // skeleton component
                        }

                        if (error) {
                            mbpLogger.logError({
                                query: FOOTER_QUERY,
                                component: 'GraphqlFooter.js',
                                message: 'Error loading data from Graphql',
                                env: GRAPHQL_ENV,
                                error,
                            });
                            return null;
                        }

                        if (!data) {
                            mbpLogger.logWarning({
                                query: FOOTER_QUERY,
                                component: 'GraphqlFooter.js',
                                message: 'No data returned for query',
                                env: GRAPHQL_ENV,
                            });
                            return null;
                        }
                        if (!data.findFooter?.content) {
                            mbpLogger.logWarning({
                                query: FOOTER_QUERY,
                                component: 'GraphqlFooter.js',
                                message: 'No content returned for query',
                                env: GRAPHQL_ENV,
                            });
                            return null;
                        }

                        if (data.findFooter.content.entries?.length) {
                            const footerData = data.findFooter.content.entries;
                            return (
                                (presentationFamily === 'growthbrand' || brand.code === 'PLA')
                                    ? (
                                        <DesktopGraphqlFooter
                                            desktopFooterData={footerData}
                                            setDialog={this.setDialog}
                                            checkTitle={this.checkTitle}
                                            presentationFamily={presentationFamily}
                                            brand={brand}
                                        />
                                    ) : (
                                        <DesktopMobile
                                            desktop={() => (
                                                <DesktopGraphqlFooter
                                                    desktopFooterData={footerData}
                                                    setDialog={this.setDialog}
                                                    checkTitle={this.checkTitle}
                                                    presentationFamily={presentationFamily}
                                                    brand={brand}
                                                />
                                            )}
                                            mobile={() => (
                                                <MobileGraphqlFooter
                                                    mobileFooterData={footerData}
                                                    setDialog={this.setDialog}
                                                    checkTitle={this.checkTitle}
                                                    presentationFamily={presentationFamily}
                                                />
                                            )}
                                        />
                                    )
                            );
                        }
                        return <div>No Footer</div>;
                    }}
                </Query>
            </footer>
        );
    }
}

GraphqlFooter.propTypes = {
    brand: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(GraphqlFooter);
